module.exports = __webpack_public_path__ + "static/cube22-d42d45c84d73858e4d2468ebeda0067f.svg";